// extracted by mini-css-extract-plugin
module.exports = {"employeeSelectionPanel":"BrmgP","employeeSelectionPanelCount":"orTap","splitter":"-IyTv","statusModalUser":"EUHVI","statusModalList":"ZnQvV"};